import gql from 'graphql-tag';

const GET_TRACEABILITY_REPORT = gql`
    query generateTraceabilityReport ($email: String!, $init: String!, $end: String!) {
        generateTraceabilityReport (email: $email, init: $init, end: $end) {
            message
            status
            data
        }
    }
`;

export default GET_TRACEABILITY_REPORT;
